body.on('change', '.SQE_zone_group', function () {
    SQEPhase2();
    SQEPhase3();
});

body.on('change', '.SQE_price_radio', function () {
    SQEPhase3();
});

function SQEPhase2() {
    let zoneGroupSQE = parseInt($('.SQE_zone_group:checked').val());
    let SQEPhase2Wrapper = $('#SQE_phase_2');

    SQEPhase2Wrapper.addClass('d-none');

    // Hide all prices where data-group !== zoneGroupSQE and unselect all radios
    SQEPhase2Wrapper.find('.SQE_price_radio_wrapper').each(function () {
        $(this).addClass('d-none');

        let radio = $(this).find('input[type="radio"]');
        $(radio).prop('checked', false);

        let priceZoneGroup = parseInt($(this).data('group'));

        if (priceZoneGroup === zoneGroupSQE) {
            $(this).removeClass('d-none');
        }
    });

    SQEPhase2Wrapper.removeClass('d-none');
}

function SQEPhase3() {
    let SQEPhase3Wrapper = $('#SQE_phase_3');
    let zoneGroupSQE = parseInt($('.SQE_zone_group:checked').val());
    let priceTableSQE = parseInt($('.SQE_price_radio:checked').val());

    SQEPhase3Wrapper.addClass('d-none');

    if (!zoneGroupSQE || !priceTableSQE) {
        return;
    }

    let partner = parseInt($('#partner').val());
    let zoneSelect = $('#zone_sqe');
    let url = zoneSelect.data('url');
    let method = zoneSelect.data('method');

    $.ajax({
        url: url,
        type: method,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
            zone_group_sqe_id: zoneGroupSQE,
            partner_id: partner,
        },
        success: function (response) {
            if (response.status === 'success') {
                SQEPhase3Wrapper.removeClass('d-none');
                zoneSelect.html(
                    '<option value="">Escolha uma zona</option>'
                );
                console.log(response.zonesSQE);
                $.each(response.zonesSQE, function (i, v) {
                    zoneSelect.append(
                        '<option value="' + v.id + '">' + v.label + '</option>'
                    );
                });


            } else {
                console.error('Error fetching zones');
            }
        },
        error: function (error) {
            console.error('Error fetching zones', error);
        }
    });
}
